// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723604843126/Frame%201000008959.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723606077376/AC%E5%BF%AB%E5%85%85.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724644109000/c1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724644109549/d1.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725153964125/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725153964300/euH1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725160504051/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725160503333/ukH1.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
    nl: imgAll1.EU,
};
export default imgLocale1;
